import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Table } from 'reactstrap';
import _, { first, sum } from 'lodash';

import { formatCurrency } from '../../../../helpers/format';

const OrderDetailSummary = (props) => {
  const { isLoading, ...summary } = useSelector(
    createSelector(
      (store) => store.Order,
      ({ order, isLoading }) => {
        const reserve = first(order?.reserve);
        const summary = order.items?.reduce(
          (acc, item) => {
            acc.subtotal += Number(item.totalPrice ?? 0);
            if (order.status === 'paid' || reserve?.status !== 'active') {
              acc.redeemed += Number(item.usedCashback) ?? 0;
            } else {
              acc.redeemed = Number(reserve?.value ?? 0);
            }
            acc.discounts += Number(item.totalDiscount ?? 0);
            acc.total +=
              Number(item.totalPrice ?? 0) - Number(item.totalDiscount ?? 0);
            return acc;
          },
          {
            subtotal: 0,
            redeemed: 0,
            discounts: 0,
            total: 0,
          }
        );

        return {
          subtotal: summary?.subtotal ?? 0,
          redeemed: summary?.redeemed ?? 0,
          discounts: summary?.discounts ?? 0,
          total: order?.totalPaid ?? summary?.total ?? 0,
          status: order.status,
          reserveStatus: reserve?.status,
          isLoading,
        };
      }
    )
  );

  const rows = [
    {
      label: props.t('order-details.summary.subtotal'),
      value: formatCurrency(summary.subtotal),
    },
    {
      label: props.t('order-details.summary.discount'),
      value: formatCurrency(summary.discounts),
    },
    {
      label: summary.status === 'paid' || summary?.reserveStatus !== 'active' ? props.t('order-details.summary.cashback-redeemed') : props.t('order-reserved-balance2'),
      value: formatCurrency(summary.redeemed),
    },
    {
      label: props.t('order-details.summary.total'),
      value: formatCurrency(summary.total),
    },
  ];

  return (
    <div className="row justify-content-end mt-4">
      <div className="col-12 col-sm-6 col-xl-5">
        <Table className="col-6 table-nowrap m-0 text-dark">
          <tbody>
            {rows.map(({ label, value, extra }, key) => (
              <tr key={`sidebar-consumer-${key}`}>
                <td className="w-50 fw-bold">{label}</td>
                <td className="w-25 fw-semibold">
                  <span>{value}</span>
                  <span>{extra ?? null}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default withTranslation()(OrderDetailSummary);
